
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M22.625 17c.375 0 .625-.25.625-.625v-2.688c0-.374-.25-.624-.625-.624s-.625.25-.625.624v2.688c0 .313.313.625.625.625zM28.875 13.063c-.375 0-.625.25-.625.624v2.688c0 .375.25.625.625.625s.625-.25.625-.625v-2.688c0-.374-.25-.624-.625-.624zM5.125 11.188c-.375 0-.625.25-.625.624v1.25c0 .376.25.626.625.626s.625-.25.625-.626v-1.25c0-.374-.25-.624-.625-.624zM5.125 16.813c-.375 0-.625.25-.625.625v1.25c0 .375.25.625.625.625s.625-.25.625-.625v-1.25c0-.375-.25-.625-.625-.625zM19.5 17c.375 0 .625-.25.625-.625v-2.688c0-.374-.25-.624-.625-.624s-.625.25-.625.624v2.688c0 .313.313.625.625.625zM16.375 17c.375 0 .625-.25.625-.625v-2.688c0-.374-.25-.624-.625-.624s-.625.25-.625.624v2.688c0 .313.313.625.625.625zM13.25 17c.375 0 .625-.25.625-.625v-2.688c0-.374-.25-.624-.625-.624s-.625.25-.625.624v2.688c0 .313.313.625.625.625zM1.125 10.563c-.375 0-.625.25-.625.624v8.126c0 .375.25.625.625.625s.625-.25.625-.625v-8.125a.626.626 0 00-.625-.626z"}}),_c('path',{attrs:{"d":"M26.875 11.188h-8v-1.25c0-.376-.25-.626-.625-.626s-.625.25-.625.626v1.25h-6.188A3.095 3.095 0 008.5 9H5.375a3.095 3.095 0 00-3.125 3.125v6.25A3.095 3.095 0 005.375 21.5H8.5c1.5 0 2.813-1.125 3.063-2.563h6.062v1c0 .375.25.625.625.625s.625-.25.625-.625v-1h8c.375 0 .625-.25.625-.625v-6.5a.626.626 0 00-.625-.624zm-16.5 7.187A1.842 1.842 0 018.5 20.25H5.375A1.842 1.842 0 013.5 18.375v-6.25c0-1.063.813-1.875 1.875-1.875H8.5c1.063 0 1.875.813 1.875 1.875v6.25zm15.875-.688H11.625v-5.25H26.25v5.25z"}})])])
          )
        }
      }
    